import { useMsal } from "@azure/msal-react";
import { loginRequest, redirectUri } from "../../../auth/microsoftConfig";
import { FaMicrosoft } from "react-icons/fa";
import axios from "axios";
import styles from "./UserOptions.module.css";

const MicrosoftButton = (props) => {
  const { instance } = useMsal();

  const handleMicrosoftLogin = async () => {
    try {
      const response = await instance.loginPopup({
        ...loginRequest,
        redirectUri,
      });

      const idToken = response?.idToken || "";

      if (!idToken) {
        throw new Error("Microsoft sign-in failed. Missing ID token.");
      }

      const { data } = await axios.post(
        "php/sign_in/microsoftSignin.php",
        { id_token: idToken },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        },
      );

      console.log("Microsoft response data:", data);

      if (data?.status === "success") {
        props.onMicrosoftSignin({
          method: "microsoft",
          callname: data.callname,
        });
      } else {
        throw new Error(data?.message || "Unexpected response from server.");
      }
    } catch (error) {
      console.error("Microsoft login error:", error);

      let message =
        "Microsoft sign-in failed. Please retry or use another method.";

      if (error.response) {
        const status = error.response.status;
        const serverMessage = error.response.data?.message;

        if (status === 401) {
          message = serverMessage || "Unauthorized. Please try again.";
        } else if (status === 500) {
          message = serverMessage || "Internal server error. Please try again.";
        } else {
          message = serverMessage || `Request failed (${status}).`;
        }
      } else if (error.request) {
        message = "Network error. Check your internet connection.";
      } else if (error.message) {
        message = error.message;
      }

      alert(message);
    }
  };

  return (
    <button
      type="button"
      className={styles.microsoftBtn}
      onClick={handleMicrosoftLogin}
    >
      Microsoft &nbsp;
      <FaMicrosoft size={20} />
    </button>
  );
};

export default MicrosoftButton;
/*
const MicrosoftButton = (props) => {
  const { instance } = useMsal();

  const handleMicrosoftLogin = async () => {
    try {
      const response = await instance.loginPopup({
        ...loginRequest,
        redirectUri:
          "http://localhost/exambits-react-axios-ownDb/auth/microsoft-callback.html",
      });
      
      const fullname = response?.account?.name || "";
      const nameParts = fullname.trim().split(" ");
      const firstname = nameParts[0] || "";
      const lastname = nameParts.slice(1).join(" ") || "";
      console.log(firstname);
      console.log(lastname);
      const email = response?.account?.username || "";
      const newUserData = {
        email: email,
        firstname: firstname,
        lastname: lastname,
      };      
      console.log("newUserData", newUserData);
      const res = await axios.post(
        "php/sign_in/microsoftSignin.php",
        newUserData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      console.log("response data:", res.data);
      if (res.data == "Access denied" || res.data == 0) {
        alert(
          "Error connecting to server. Check your internet connection or retry later",
        );
      } else {
        props.onMicrosoftSignin({
          method: "microsoft",
          callname: firstname,
        });
      }
    } catch (error) {
      console.error("Microsoft login error:", error);
      console.error("Microsoft login error:", error);
      console.error("errorCode:", error?.errorCode);
      console.error("subError:", error?.subError);
      console.error("message:", error?.message);
    }
  };

  return (
    <button
      type="button"
      className={styles.microsoftBtn}
      onClick={handleMicrosoftLogin}
    >
      Microsoft &nbsp;
      <FaMicrosoft size={20} />
    </button>
  );
};

export default MicrosoftButton;
*/
/*
Microsoft user: 
{
  "name": "Olusesan Adabonyan",
  "email": "olu.adabonyan@live.com",
  "id": "00000000-0000-0000-fd24-63e81658f326.9188040d-6c67-4c5b-b112-36a304b66dad",
  "provider": "microsoft"
}

*/
